
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.633.836l2.655 2.827a.22.22 0 00.319.005.24.24 0 00.004-.33L3.871.42a.222.222 0 00-.162-.07h-.152c-.06 0-.119.025-.161.07L.656 3.338a.24.24 0 00.004.33.22.22 0 00.318-.005L3.633.836z","fill":"#000","stroke":"#000"}}),_c('path',{attrs:{"d":"M.798 7.5h6","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    